import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Label } from "./index.styled";

interface TableCounterProps {
    count: number;
    total: number;
    inProcess?: number;
}
const TableCounter: React.FC<TableCounterProps> = ({ count, total, inProcess }) => {
    const { t } = useTranslation("private-home-page");

    const countFormated = useMemo(() => {
        return  Intl.NumberFormat("pt-BR").format(count).toString();
    }, [count]);

    const totalFormated = useMemo(() => {
        return new Intl.NumberFormat("pt-BR").format(total).toString();
    }, [total]);

    const hasInProcess = useMemo(() => {
        return inProcess && inProcess > 0;
    }, [inProcess]);

    const inProcessFormated = useMemo(() => {
        return inProcess && inProcess > 0 ? new Intl.NumberFormat("pt-BR").format(inProcess).toString() : 0;
    }, [inProcess]);

    return (
        <Container>
            <Label>{t('ranking-table.showing-total', {total: totalFormated, couting: countFormated})}{hasInProcess ? t('ranking-table.in-process', {total: inProcessFormated}) : ''}</Label>
            
        </Container>
    );
};

export default TableCounter;